// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"21":"7a6d70b3","196":"126fe942","892":"3617167d"}[chunkId] + ".css";
};